import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-test-15",
  "use": "icon-test-15-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-test-15\"><path d=\"M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z\" fill=\"#FFFFFF\" p-id=\"25634\" /><path d=\"M512 512m-448 0a448 448 0 1 0 896 0 448 448 0 1 0-896 0Z\" fill=\"#53B0FF\" p-id=\"25635\" /><path d=\"M771.2 768a152 152 0 0 0-105.6-72 124.8 124.8 0 0 1-147.2 0 152 152 0 0 0-105.6 72h358.4z\" fill=\"#FFFFFF\" p-id=\"25636\" /><path d=\"M592 592m-96 0a96 96 0 1 0 192 0 96 96 0 1 0-192 0Z\" fill=\"#FFFFFF\" p-id=\"25637\" /><path d=\"M704 320v-32a32 32 0 0 0-32-32H288a32 32 0 0 0-32 32v32zM529.6 480a139.2 139.2 0 0 1 62.4-16 128 128 0 0 1 60.8 16H704v-64H256v64zM465.6 576H256v32a32 32 0 0 0 32 32h185.6a116.8 116.8 0 0 1-9.6-48 54.4 54.4 0 0 1 1.6-16z\" fill=\"#FFFFFF\" p-id=\"25638\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/test-15.svg
// module id = 5mxA
// module chunks = 48